import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { RxCross2 } from "react-icons/rx";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import { FaRedoAlt, FaFilePdf } from "react-icons/fa"; // PDF icon
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Custom styles for react-select component
const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "480px",
    height: "24px",
    "@media (max-width: 768px)": {
      width: "300px",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    maxHeight: "180px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "150px",
    overflowY: "auto",
    fontSize: "16px",
  }),
  control: (provided) => ({
    ...provided,
    minHeight: "30px",
    height: "36px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    height: "14px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "8px",
    svg: {
      width: "18px",
      height: "18px",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
    marginBottom: "10px",
    color: "#004999",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "16px",
    marginBottom: "10px",
    color: "#004999",
  }),
  input: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const translations = {
  en: {
    heading: "Upload National Identity Proof (Aadhar/Pan/Driving License)",
    errorFile: "Please select the document type before uploading.",
    ok: "OK",
    selectLanguage: "Select the Document:",
    chooseFiles: "Choose Files",
    File:"File already uploaded",
    moveError:"Please answer the current question before proceeding to the next one.",

  },
  Hi: {
    heading: "राष्ट्रीय पहचान पत्र अपलोड करें (आधार/पैन/ड्राइविंग लाइसेंस)",
    errorFile: "अपलोड करने से पहले कृपया दस्तावेज़ प्रकार चुनें।",
    ok: "ठीक है",
    selectLanguage: "भाषा चुनें:",
    chooseFiles: "फ़ाइल चुनें",
    File: "फ़ाइल पहले ही अपलोड की जा चुकी है",
    moveError:"कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",

  },
  Kn: {
    heading:
      "ರಾಷ್ಟ್ರೀಯ ಗುರುತಿನ ಚೀಟಿ (ಆಧಾರ್/ಪ್ಯಾನ್ ಕಾರ್ಡ್/ಚಾಲನಾ ಪರವಾನಗಿ) ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    errorFile: "ಅಪ್ಲೋಡ್ ಮಾಡುವ ಮೊದಲು ದಯವಿಟ್ಟು ದಾಖಲೆ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    ok: "ಸರಿ",
    selectLanguage: "ಆಯ್ಕೆ ಮಾಡಿ:",
    chooseFiles: "ಫೈಲ್‌ ಅಯ್ಕೆ",
     File: "ಫೈಲ್ ಈಗಾಗಲೇ ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
     moveError:"ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
  },
};

const UploadNationalId = ({
  onNext,
  onNationalIdUploaded,
  onQuestion,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang,
  answer
}) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [nationalId, setNationalId] = useState(null);
  const [rawNationalData, setRawNationalData] = useState(null);
  const [NationalOptions, setNationalOptions] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const fileInputRef = useRef(null);
  const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB in bytes
  const audioRef = useRef(null);
  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/Eng-Audio6A.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio6A.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio6A.m4a",
  };

  // Update audio source on language or play status change
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);


       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  const getNationalList = (resp, language) => {
    switch (language) {
      case "en":
        return resp.lang_eng;
      case "Hi":
        return resp.lang_hin;
      case "Kn":
        return resp.lang_kanada;
      default:
        return resp.lang_eng; // fallback
    }
  };

  useEffect(() => {
    if (rawNationalData) {
      const districtList = getNationalList(rawNationalData, selectedLang) || [];
      setNationalOptions(
        districtList.map((address, index) => ({
          id: String.fromCharCode(65 + index),
          value: address.prof_uniq,
          label: address.prof_nm,
        })) || []
      );
    }
  }, [selectedLang, rawNationalData]);

  // Load any previously stored file info from localStorage on mount.
  useEffect(() => {
    const storedNationalId = localStorage.getItem("nationalId");
    const storedNationalFile = localStorage.getItem("nationalFile");
    if (storedNationalId) {
      // Since the file information was stored as a JSON string (in this demo it's just the file name)
      const data = JSON.parse(storedNationalId);
      const file = JSON.parse(storedNationalFile);
      setNationalId(data);
      setFile(file);
      onNationalIdUploaded(data);
    }
  }, []);

  useEffect(() => {
    const fetchProfessionData = async () => {
      try {
        const nationalResponse = await fetch(
          `${apiUrl}/v1/cy_ma_proof_typ_list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "67fca268bac11174066666",
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id:
                selectedLang === "en"
                  ? "2"
                  : selectedLang === "Hi"
                  ? "3"
                  : selectedLang === "Kn"
                  ? "1"
                  : "4",
            }),
          }
        );

        if (!nationalResponse.ok) {
          throw new Error("Failed to fetch profession options");
        }

        const nationalData = await nationalResponse.json();
        if (nationalData.resp.error_code === "0") {
          setRawNationalData(nationalData.resp);
          // setRawProfessionData(ProfessionData.resp);
          // const ProfessionList = getProfessionList(ProfessionData.resp, selectedLang) || [];
          // setProfessionOptions(
          //   ProfessionList.map((profession, index) => ({
          //     id: String.fromCharCode(65 + index),
          //     value: profession.prof_uniq,
          //     label: profession.prof_nm,
          //   })) || []
          // );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchProfessionData();
  }, [apiKey, app_ver, botToken, vist_id]);
  // Update the file state when a file is selected
  // const handleFileChange = (e) => {
  //   const selectedFile = e.target.files?.[0];
  //   if (selectedFile) {
  //     setFile(selectedFile);
  //     setError(null);
  //   }
  // };

  const handleNationalChange = (selectedOption) => {
    setNationalId(selectedOption);
    setError("");
  };

  const handleFileClick = (e) => {
    // If no nationalId is chosen, prevent opening the file dialog
    if (!nationalId) {
      e.preventDefault();
      setError('errorFile');
    }
    if(file){
      e.preventDefault();
      setError('File');
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files?.[0];
    const isSizeValid = selectedFile.size <= MAX_UPLOAD_SIZE;
    if (
      !isSizeValid ||
      !selectedFile ||
      !nationalId ||
      typeof selectedFile === "string"
    ) {
      setError('errorFile');
      return;
    }

    const formData = new FormData();
    formData.append("userImage", selectedFile);
    formData.append("api_key", apiKey);
    formData.append("visitor_token", vist_id);
    formData.append("qtion_id", "67fca268bac11174066666");
    formData.append("qtion_num", "6A");
    formData.append("lac_token", botToken);
    formData.append("prof_uniq", nationalId.value);
    formData.append("app_ver", app_ver);
    formData.append("ref_id", "670fce3010e33775926208");
    try {
      setIsUploading(true);
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_proof_doc`, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        throw new Error("Failed to upload file to API");
      }

      const data = await response.json();

      if (data.resp.error_code === "0") {
        // For demo purposes, store only the file name
        if (selectedFile) {
          setFile(selectedFile);
          const objectUrl = URL.createObjectURL(selectedFile);
          setPreviewUrl(objectUrl);
          setError(null);
        }
        const fileName =
          typeof selectedFile === "object" ? selectedFile.name : file;
        localStorage.setItem("nationalFile", JSON.stringify(fileName));
        localStorage.setItem("nationalId", JSON.stringify(nationalId));
        onNationalIdUploaded(fileName);
        setError(null);
      } else {
        setError("Failed to upload file to API");
        // onNext(7);
        // onQuestion(8);
      }
    } catch (err) {
      console.error("Error uploading file to API:", err);
      setError("Error uploading file to API");
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    // Clean up the object URL when component unmounts or when a new file is selected.
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  // Upload the selected file to the API
  const handleUpload = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    onNext(7);
    onQuestion(8);
  };

  const handleRemoveFile = async (index, uuid) => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_remove_proof_doc`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "67fca268bac11174066666",
          qtion_num: "6A",
          option_val: "670fce3010e33775926208",
          lac_token: botToken,
          app_ver: app_ver,
          ref_id: "670fce3010e33775926208",
          bot_lang_id:
            selectedLang === "en"
              ? "2"
              : selectedLang === "Hi"
              ? "3"
              : selectedLang === "Kn"
              ? "1"
              : "4",
        }),
      });
      const result = await response.json();
      if (result.resp.error_code === "0") {
        setFile(null);
        setPreviewUrl(null);
        localStorage.removeItem("nationalFile");
        localStorage.removeItem("nationalId");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        // setFiles((prevFiles) => prevFiles.filter((file) => file.uuid !== uuid));
        // const updatedFiles = JSON.parse(localStorage.getItem("BankFile")).filter(
        //   (file) => file.uuid !== uuid
        // );
        // localStorage.setItem("BankFile", JSON.stringify(updatedFiles));
        // submitSupport(updatedFiles);
        // document.getElementById("file-upload").value = "";
      } else {
        // setErrorMessage("Failed to delete the file.");
      }
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", justifyContent: "center",alignItems: "center" }}>
          <div style={{ display: "flex", flexDirection: "column",justifyContent: "center" }}>
            <div style={{ display: "flex" }}>
              <h2 >
                {translations[selectedLang].heading}{" "}
                <span style={{ color: "red" }}>*</span>
              </h2>
              <button onClick={toggleAudio} className="audio-button">
                {isPlaying ? (
                  <FaPause color="White" size={12} style={{ marginBottom: '20px' }}/>
                ) : (
                  <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>
                )}
              </button>
            </div>

            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>

            <div style={{ marginBottom: "20px" }}>
              <h6 style={{ margin: "5px", marginTop: "20px" }}>
                {translations[selectedLang].selectLanguage}
              </h6>
              <Select
                options={NationalOptions}
                styles={customStyles}
                onChange={handleNationalChange}
                value={
                  NationalOptions?.find(
                    (option) => option.value === nationalId?.value
                  ) || null
                }
              />
            </div>
            <div style={{ marginTop: "20px" }}>
              <input
                ref={fileInputRef}
                type="file"
                id="id-upload"
                accept=".jpeg,.pdf,.jpg,.jpeg,.png"
                onClick={handleFileClick}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <label htmlFor="id-upload" className="upload-file">
                  {translations[selectedLang].chooseFiles}
                </label>
                {file && (
                  <button
                    type="button"
                    style={{ width: "95px", zIndex: "9" }}
                    className="ok-btn"
                    onClick={handleUpload}
                  >
                    {isUploading
                      ? "Uploading..."
                      : `${translations[selectedLang].ok}`}
                  </button>
                )}
              </div>
            </div>
            <div style={{ marginTop: "20px" }}>
              {error && (
                <div className="error-message" style={{ color: "red" }}>
                  {translations[selectedLang][error]}
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              {file && (
                <div
                  className="file-container"
                  style={{ position: "relative", display: "inline-block" }}
                >
                  {file.type === "application/pdf" ? (
                    <div
                      className="pdf-preview"
                      style={{ textAlign: "center" }}
                    >
                      <FaFilePdf size={50} color="red" />
                      <p style={{ fontSize: "8px" }}>{file.name}</p>
                    </div>
                  ) : (
                    <img
                      src={previewUrl}
                      alt={file.name}
                      className="preview-image"
                      style={{ maxWidth: "200px", maxHeight: "200px" }}
                    />
                  )}
                  <button
                    type="button"
                    onClick={() => handleRemoveFile()}
                    className="remove-button"
                    style={{ zIndex: "9" }}
                  >
                    <RxCross2 />
                  </button>
                </div>
              )}
            </div>
            {answer[6] && (
            <p className="alert-box">
              {translations[selectedLang].moveError}
            </p>
          )} 
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadNationalId;
